export default __webpack_public_path__ + "static/media/join_background_right.a648bf72.png";